import { useState } from "react";

import { ActionsMenu, ActionsMenuButton, MenuItem } from "ui/actions-menu";
import AddNewProgramTemplateModal from "containers/admin/clients/client/program-templates-page/components/add-new-program-template-modal/add-new-program-template-modal";

import { useCreateProgramTemplate } from "containers/admin/clients/client/program-templates-page/hooks/use-create-program-template";
import { TouchpointCreateRequestType } from "generated/schemas";

import type { AddNewProgramTemplateFormData } from "containers/admin/clients/client/program-templates-page/program-templates-page.types";

import Icons from "assets";

interface NewProgramTemplateDropdownProps {
  onTemplateCreated?: () => void;
}

const NewProgramTemplateDropdown = ({ onTemplateCreated }: NewProgramTemplateDropdownProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState<TouchpointCreateRequestType>(
    TouchpointCreateRequestType.EMAIL,
  );

  const handleDropdownOpen = () => setIsDropdownOpen(true);
  const handleDropdownClose = () => setIsDropdownOpen(false);

  const { createProgramTemplate, submitState, resetState } = useCreateProgramTemplate(() => {
    setIsModalOpen(false);
    onTemplateCreated?.();
  });

  const handleSelectType = (type: TouchpointCreateRequestType) => {
    setSelectedType(type);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedType(TouchpointCreateRequestType.EMAIL);
    resetState();
  };

  const handleModalSubmit = (
    data: AddNewProgramTemplateFormData,
    templateType: TouchpointCreateRequestType,
  ) => {
    createProgramTemplate(data, templateType);
  };

  return (
    <>
      <ActionsMenu
        itemName="new program template"
        open={isDropdownOpen}
        onOpen={handleDropdownOpen}
        onClose={handleDropdownClose}
        menuId="new-program-template-menu"
        offsetLeft={2}
        offsetTop={10}
        trigger={<ActionsMenuButton size="large">Create template</ActionsMenuButton>}>
        <MenuItem
          icon={<Icons.Email />}
          label="Email"
          onClick={() => handleSelectType(TouchpointCreateRequestType.EMAIL)}
        />
        <MenuItem
          icon={<Icons.LandingPage />}
          label="Web page"
          onClick={() => handleSelectType(TouchpointCreateRequestType.LANDING_PAGE)}
        />
        <MenuItem
          icon={<Icons.Other />}
          label="Other"
          onClick={() => handleSelectType(TouchpointCreateRequestType.OTHER)}
        />
      </ActionsMenu>

      <AddNewProgramTemplateModal
        isOpen={isModalOpen}
        templateType={selectedType}
        onClose={handleModalClose}
        onSubmit={handleModalSubmit}
        submitState={submitState}
      />
    </>
  );
};

export default NewProgramTemplateDropdown;
